import { render, staticRenderFns } from "./SupRecommendDialog.vue?vue&type=template&id=6fc17c58&"
import script from "./SupRecommendDialog.vue?vue&type=script&lang=js&"
export * from "./SupRecommendDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports